import { createFileRoute } from "@tanstack/react-router";

import { MAIN_LOCATION } from "@/data/cars";
import { publicPageHeaders } from "@/lib/http-cache";

const title = "Privacy Policy — Car Rental Bucharest";
const description =
  "How Car Rental Bucharest collects, uses, stores and protects the personal data you share when booking a car in Bucharest, fully in line with the GDPR.";

export const Route = createFileRoute("/privacy-policy")({
  headers: publicPageHeaders,
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:url", content: "https://carentals.ro/privacy-policy" },
    ],
    links: [{ rel: "canonical", href: "https://carentals.ro/privacy-policy" }],
  }),

  component: PrivacyPolicyPage,
});

const sections = [
  {
    heading: "1. Who we are",
    body: `Car Rental Bucharest (carentals.ro) operates a car rental service in Bucharest, Romania, with its main pickup point at ${MAIN_LOCATION}. You can reach us at book@carentals.ro or on WhatsApp at +40 738 792 499.`,
  },
  {
    heading: "2. What data we collect",
    body: "We collect the information you provide when booking a car: name, email address, phone number, driver's license details, billing information and rental dates. We also collect limited technical data such as your IP address and cookie preferences.",
  },
  {
    heading: "3. Why we process your data",
    body: "We process your data to prepare and fulfil your rental agreement, to comply with legal and fiscal obligations, to prevent fraud, and — where you have consented — to send you offers about our fleet.",
  },
  {
    heading: "4. Cookies",
    body: "We use strictly necessary cookies to keep the site working and, with your consent, analytics cookies to understand how visitors use the website. You can accept or decline non-essential cookies through the banner shown on your first visit.",
  },
  {
    heading: "5. Sharing your data",
    body: "We share data only with parties required to deliver the service: payment processors, insurance partners and, where legally required, public authorities. We never sell your personal data.",
  },
  {
    heading: "6. Retention",
    body: "Rental contracts and invoices are kept for the period required by Romanian fiscal law. Marketing consents are kept until you withdraw them.",
  },
  {
    heading: "7. Your rights",
    body: "Under the GDPR you may request access to, rectification of, or erasure of your personal data, restrict or object to processing, and request data portability. Write to book@carentals.ro and we will answer within 30 days. You may also lodge a complaint with the Romanian data protection authority (ANSPDCP).",
  },
  {
    heading: "8. Dispute resolution",
    body: "Consumers may use the European Online Dispute Resolution platform at ec.europa.eu/consumers/odr or contact ANPC for complaints regarding our services.",
  },
];

function PrivacyPolicyPage() {
  return (
    <div className="container-page max-w-3xl py-16">
      <p className="eyebrow">Legal</p>
      <h1 className="mt-3 text-3xl font-bold sm:text-4xl">Privacy Policy</h1>
      <p className="mt-4 text-muted-foreground">
        Last updated: {new Date().getFullYear()}. This policy explains how we handle personal data
        in compliance with Regulation (EU) 2016/679 (GDPR).
      </p>

      <div className="mt-10 space-y-8">
        {sections.map((section) => (
          <section key={section.heading}>
            <h2 className="font-display text-lg font-bold">{section.heading}</h2>
            <p className="mt-2 leading-relaxed text-muted-foreground">{section.body}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
